import React, { ReactNode } from 'react';
import { Card } from './Card';

interface StatCardProps {
  title: string;
  value?: string | number;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
  valueClassName?: string;
  titleClassName?: string;
}

export const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon,
  children,
  className = '',
  valueClassName = 'text-2xl font-bold text-gray-900 dark:text-dark-text-primary',
  titleClassName = 'text-sm text-gray-600 dark:text-dark-text-secondary'
}) => {
  return (
    <Card className={`bg-white dark:bg-dark-secondary ${className}`}>
      <div className="flex flex-col items-center justify-center text-center h-full">
        {icon && (
          <div className="flex-shrink-0 bg-brand-teal/20 text-brand-teal rounded-full p-3 mb-2">
            {icon}
          </div>
        )}
        <div>
          <p className={titleClassName}>{title}</p>
          {children ? (
            <div className='mt-1'>{children}</div>
          ) : (
            <p className={valueClassName}>{value}</p>
          )}
        </div>
      </div>
    </Card>
  );
};